import { toast } from 'react-toastify';

function showCopyErrorToast(error?: string) {
  const message = 'Could not copy text';

  if (error) {
    console.debug(`${message}: `, error);
  }

  toast.error(`${message}. Please do it manually`);
}

export function copyToClipboardWithToast(text: string) {
  if (!text) {
    return;
  }

  if (!navigator.clipboard) {
    showCopyErrorToast('navigator.clipboard is not available');
    return;
  }

  navigator.clipboard.writeText(text).then(
    () => {
      toast.success('Copied to clipboard!', { toastId: 'copyToClipboard' });
    },
    (error) => {
      showCopyErrorToast(error);
    },
  );
}
